import { pctStr, rowTotal } from "./sgkConst";

const inp = "w-20 px-2 py-1 text-sm text-center border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";

function Cell({ value, editable, onChange, testid, placeholder }) {
  if (!editable) return <span data-testid={testid}>{pctStr(value)}</span>;
  return <input value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} inputMode="decimal" className={inp} placeholder={placeholder || "0"} />;
}

// Tek prim satırı: İşveren % · Çalışan % · Toplam % (otomatik); SGDP satırında işveren = oran + KVSK
export default function SgkRateRow({ rowKey, label, values, editable, extraLabel, onChange, prefix }) {
  const upd = (f) => (v) => onChange(rowKey, f, v);
  const total = rowTotal(values);
  const employerView = extraLabel && values?.extra != null && values?.extra !== "" ? `${pctStr(values.employer)} + ${pctStr(values.extra)} (${extraLabel})` : null;
  return (
    <tr className="border-t border-slate-200" data-testid={`${prefix}-row-${rowKey}`}>
      <td className={`px-3 py-1.5 text-sm ${extraLabel ? "font-bold text-sky-700" : "text-slate-800"}`}>{label}</td>
      <td className="px-3 py-1.5 text-sm text-center">
        {editable
          ? <span className="inline-flex items-center gap-1"><Cell editable value={values?.employer} onChange={upd("employer")} testid={`${prefix}-employer-${rowKey}`} />{extraLabel && <>+ <Cell editable value={values?.extra} onChange={upd("extra")} testid={`${prefix}-extra-${rowKey}`} placeholder={extraLabel} /><span className="text-[11px] text-slate-500">({extraLabel})</span></>}</span>
          : <span data-testid={`${prefix}-employer-${rowKey}`}>{employerView ?? pctStr(values?.employer)}</span>}
      </td>
      <td className="px-3 py-1.5 text-sm text-center"><Cell editable={editable} value={values?.employee} onChange={upd("employee")} testid={`${prefix}-employee-${rowKey}`} placeholder="-" /></td>
      <td className={`px-3 py-1.5 text-sm text-center font-semibold ${extraLabel ? "bg-slate-200" : ""}`} data-testid={`${prefix}-total-${rowKey}`}>{pctStr(total)}</td>
    </tr>
  );
}
